export default __webpack_public_path__ + "static/media/LAS0090.34I-30556_-17569_0.5e5eff53.jpg";